<page-title [title]="title"></page-title>
<p>Veja abaixo os exames/procedimentos disponíveis, se preferir, realize sua busca no campo abaixo:</p>
<div class="row busca">
  <div class="col-xs-12">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Digite sua busca pelo nome do exame ou procedimento</mat-label>
      <input type="text" matInput [(ngModel)]="search" placeholder="Digite aqui sua busca" />
    </mat-form-field>
  </div>
  <div class="col-xs-12 col-sm-10 col-md-9 col-lg-11 rangeBar">
    <mat-label for="distanceRange">Escolha o raio de busca dos procedimentos (km):</mat-label>
    <mat-slider style="width: 100%" thumbLabel [displayWith]="formatLabel" tickInterval="1000" min="5000" max="50000" [(ngModel)]="distance">
    </mat-slider>
  </div>

  <div class="col-xs-12 col-sm-2 col-md-3 col-lg-1 btBuscarRow">
    <button mat-flat-button color="primary" (click)="getProceduresNearest()" [disabled]="loading">Buscar</button>
  </div>
  <div [ngClass]="hasButton()">
    <page-alert [message]="message" *ngIf="showMessage" alertClass="alert-warning"></page-alert>
  </div>
  <div *ngIf="latLong.length == 0" class="col-xs-12 col-sm-6 col-md-10 col-lg-4">
    <button mat-stroked-button color="primary" (click)="getCurrentPosition()" class="text-center btAtivar">Clique aqui para ativar localização</button>
  </div>
</div>

<ng-container *ngIf="latLong.length > 0 && procedures.length > 0">
  <div class="col-xs-12 col-lg-6" *ngFor="let procedure of paginatedProcedures">
    <mat-card (click)="openComponentDialogScheduleRegistrationForm(procedure)">
      <div class="content">
        <b>{{ procedure.name }} <br /><span [innerHTML]="getHospitalName(procedure)"></span></b>
        <div [innerHTML]="getCity(procedure.organization.organization_id) ?? 'Sem Endereço'"></div>
      </div>
    </mat-card>
  </div>
</ng-container>

<div class="pagination-controls">
  <button mat-button color="warn" (click)="previousPage()" [disabled]="currentPage === 0">Anterior</button>
  <span>Página {{ currentPage + 1 }} de {{ totalPages }}</span>
  <button mat-button color="primary" (click)="nextPage()" [disabled]="currentPage === totalPages - 1">Próximo</button>
</div>
